var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import MainLayout from "../../layouts/MainLayout";
import { getSystemPropertiesService } from "../../services/user-service";
import { getUserInfo } from "../../store/authentication/actions";
import { isLoadingUserInfo, userInfoData, } from "../../store/authentication/reducer";
import { notificationGlobalData } from "../../store/notification/reducer";
import { getCurrentUserDetails } from "../../utils/CommonUtil";
import * as Constant from "../../utils/Constant";
import "./index.scss";
import { LoadingDefault } from "../../components/common/loading/loading";
var SYS_USER_KEY = "SYS_USER";
var APISettingPage = function (props) {
    var userInfoData = props.userInfoData, isLoadingUserInfo = props.isLoadingUserInfo;
    var t = useTranslation().t;
    var currentUserLocalStorage = getCurrentUserDetails();
    var _a = useState({}), currentUser = _a[0], setCurrentUser = _a[1];
    var _b = useState(false), isLoading = _b[0], setLoading = _b[1];
    var _c = useState(""), publicApiUrl = _c[0], setPublicApiUrl = _c[1];
    useEffect(function () {
        if (props.userInfoData) {
            setCurrentUser(props.userInfoData);
        }
    }, [userInfoData]);
    useEffect(function () {
        if (!(currentUserLocalStorage === null || currentUserLocalStorage === void 0 ? void 0 : currentUserLocalStorage.id))
            return;
        props.dispatch(getUserInfo(currentUserLocalStorage === null || currentUserLocalStorage === void 0 ? void 0 : currentUserLocalStorage.id, true));
        getSystemProperties();
        document.title = t("page.api_setting") + Constant.APP_NAME;
    }, []);
    var getSystemProperties = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, getSystemPropertiesService()];
                case 1:
                    data = _a.sent();
                    setPublicApiUrl(data === null || data === void 0 ? void 0 : data.public_api_url);
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleRedirectToAPIDocument = function () { };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "layout-static" },
            React.createElement("div", { className: "static-content-wrapper" },
                React.createElement("div", { className: "static-content" },
                    React.createElement("div", { className: "page-content" },
                        React.createElement("div", { className: "container-api-setting" }, isLoadingUserInfo ? (React.createElement(LoadingDefault, null)) : (currentUser === null || currentUser === void 0 ? void 0 : currentUser.operationalUserType) === SYS_USER_KEY ? (React.createElement("div", { className: "panel alert-list-container" },
                            React.createElement("div", { className: "panel-heading" },
                                React.createElement(Grid, { container: true, direction: "row", justify: "space-between", alignItems: "center", className: "" },
                                    React.createElement("div", { className: "api-setting-text" }, t("api_setting.api_setting")),
                                    React.createElement("a", { href: publicApiUrl, target: "_blanch", onClick: handleRedirectToAPIDocument, className: "api-docs-text text-primary" }, t("api_setting.api_document")))),
                            React.createElement("div", { className: "panel-body" },
                                React.createElement("div", { className: "token-container" },
                                    React.createElement("p", null, (currentUser === null || currentUser === void 0 ? void 0 : currentUser.apiAccessToken) ? "AdTran " + (currentUser === null || currentUser === void 0 ? void 0 : currentUser.apiAccessToken)
                                        : "-"))))) : (React.createElement("div", { className: "panel notification" },
                            React.createElement("h3", { className: "notification__title" }, t("api_setting.api_setting_alert")),
                            React.createElement("p", { className: "notification__content" }, t("api_setting.operational_user_type_error")))))))))));
};
function mapStateToProps(state) {
    return {
        userInfoData: userInfoData(state),
        isLoadingUserInfo: isLoadingUserInfo(state),
        notificationGlobalCountData: notificationGlobalData(state),
    };
}
export default connect(mapStateToProps)(APISettingPage);
